/**
 * Listado de zonas horarias IANA. Si el navegador soporta Intl.supportedValuesOf('timeZone')
 * usa la lista oficial; si no, cae a un fallback curado de las zonas más comunes.
 *
 * Cada entrada es { value: "Europe/Madrid", label: "(GMT+2) Europe/Madrid" } para usar
 * directamente en <Select>.
 */
const FALLBACK = [
  "UTC",
  "Europe/Madrid",
  "Europe/London",
  "Europe/Paris",
  "Europe/Berlin",
  "Europe/Lisbon",
  "Europe/Dublin",
  "Europe/Rome",
  "Europe/Amsterdam",
  "America/New_York",
  "America/Chicago",
  "America/Denver",
  "America/Los_Angeles",
  "America/Mexico_City",
  "America/Bogota",
  "America/Lima",
  "America/Santiago",
  "America/Argentina/Buenos_Aires",
  "America/Sao_Paulo",
  "America/Caracas",
  "Africa/Casablanca",
  "Asia/Tokyo",
  "Asia/Shanghai",
  "Asia/Singapore",
  "Asia/Dubai",
  "Australia/Sydney",
];

function listIanaZones() {
  try {
    if (typeof Intl !== "undefined" && typeof Intl.supportedValuesOf === "function") {
      const zones = Intl.supportedValuesOf("timeZone");
      if (Array.isArray(zones) && zones.length > 0) return zones;
    }
  } catch (_) {
    // ignore
  }
  return FALLBACK;
}

function offsetFor(tz) {
  try {
    const fmt = new Intl.DateTimeFormat("en", {
      timeZone: tz,
      timeZoneName: "shortOffset",
    });
    const parts = fmt.formatToParts(new Date());
    return parts.find((p) => p.type === "timeZoneName")?.value || "";
  } catch (_) {
    return "";
  }
}

export const TIMEZONES = listIanaZones().map((tz) => {
  const off = offsetFor(tz);
  return { value: tz, label: off ? `(${off}) ${tz}` : tz };
});

export const localTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  } catch (_) {
    return "";
  }
};
